module.exports = __webpack_public_path__ + "img/AI ChatMate.edfe95c7.svg";